import React from "react";
import { FormulaWithFinancialMeta } from "../../formula/FormulaWithFinancialMeta/FormulaWithFinancialMeta";
import { FormulawithFinancialMetaStore } from "../../formula/FormulaWithFinancialMeta/FormulaWithFinancialMetaStore";
import { edCompField, ParamsEditorInfo2 } from "../ParamsEditorInfo2";
import { Addon } from "./common";

interface Props {
  props: ParamsEditorInfo2;
}

export const FormulaWithFinancialEdProps: React.FC<Props> = ({
  props: { attrTypesDict, curAttrId, loadObjectOptions, objectId },
}) => {
  const formulaFinancialMetaStore = React.useMemo(
    () =>
      new FormulawithFinancialMetaStore({
        objectOptionsLoader: loadObjectOptions,
        name: edCompField("financialData"),
        objectId,
        curAttrId,
        attrTypesDict,
      }),
    [attrTypesDict],
  );

  return (
    <>
      <FormulaWithFinancialMeta store={formulaFinancialMetaStore} />
      <Addon />
    </>
  );
};
